import { render, staticRenderFns } from "./goodsCheck.vue?vue&type=template&id=145d3130"
import script from "./goodsCheck.vue?vue&type=script&lang=ts"
export * from "./goodsCheck.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports